import { render, staticRenderFns } from "./ReportGuestOrderCardMobile.vue?vue&type=template&id=53bdea91&scoped=true"
import script from "./ReportGuestOrderCardMobile.vue?vue&type=script&lang=js"
export * from "./ReportGuestOrderCardMobile.vue?vue&type=script&lang=js"
import style0 from "./ReportGuestOrderCardMobile.vue?vue&type=style&index=0&id=53bdea91&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bdea91",
  null
  
)

export default component.exports